// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"894":"25b9dd1a","1483":"25b9dd1a","2234":"25b9dd1a","2642":"25b9dd1a","3421":"25b9dd1a","3808":"25b9dd1a","6244":"04eea54e","7914":"25b9dd1a","8855":"04eea54e"}[chunkId] + ".chunk.css";
};